import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';
import { DomainManagerService } from '../service/domain-manager.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
  public activeTab: any;
  username: any;

  isDropdownOpen = false;

  // for mobile collapse toggle
  mobileCollapsed = true;
  routerSub!: Subscription;
  isRadiologyDomain: boolean = false;
  logoUrl: string = '';

  // submenu open/close states
  isOpen: { [key: string]: boolean } = {
    clients: false,
    logs: false
  };

  constructor(public router: Router, private readonly domainService: DomainManagerService) { }

  ngOnInit() {
    this.isRadiologyDomain = this.domainService.isRadiologyDomain;
    this.logoUrl = this.domainService.getLogoUrl();
    this.username = JSON.parse(localStorage['loginData'] ?? '{}');

    // Close menus on route navigation
    this.routerSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.closeAllDropdowns();
        this.mobileCollapsed = true;
      }
    });
  }

  navigate() {
    this.router.navigate(['/user']);
  }

  navigator() {
    this.router.navigate(['/dashboard']);
  }
  onLogout() {

    localStorage.setItem('isLogin', JSON.stringify(false))
    this.router.navigate(['login']);
    localStorage.clear();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;

    const clickedInsideUserDropdown = !!target.closest('.dropdown-container');

    const clickedInsideNavDropdown = !!target.closest('.nav-dropdown');

    if (!clickedInsideUserDropdown) {
      this.isDropdownOpen = false;
    }

    if (!clickedInsideNavDropdown) {
      this.closeAllDropdowns();
    }
  }

  @HostListener('document:focusin', ['$event'])
  onDocumentFocusIn(event: FocusEvent) {
    const target = event.target as HTMLElement;
    const focusedInsideNavDropdown = !!target.closest('.nav-dropdown');

    if (!focusedInsideNavDropdown) {
      this.closeAllDropdowns();
    }
  }

  toggleDropdown(event: Event, key: string) {
    event.stopPropagation();
    this.isOpen[key] = !this.isOpen[key];
  }

  closeAllDropdowns() {
    for (const key of Object.keys(this.isOpen)) {
      this.isOpen[key] = false;
    }
  }

  toggleSubmenu(event: Event, key: string) {
    event.preventDefault();
    for (const k of Object.keys(this.isOpen)) {
      if (k === key) {
        this.isOpen[k] = !this.isOpen[k];
      } else {
        this.isOpen[k] = false;
      }
    }
  }

  ngOnDestroy() {
    this.routerSub?.unsubscribe();
  }
}
